import { addKeyToAccount } from 'flow/transactions/account';
import React, { useState } from 'react';
import { Button, Modal, Form, ModalHeader, ModalBody, ModalFooter, FormGroup, InputGroup, InputGroupAddon, Input, InputGroupText, Label } from 'reactstrap';

function AddSocialRecoveryModal({modal, toggle, args}) {
    

    function loginWithGithub(){
        window.location.assign(`https://github.com/login/oauth/authorize?client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}`)
    }
  return (
    <div>

      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Choose Provider</ModalHeader>
        <ModalBody>
        <Button className="btn btn-success" style={{"margin-left":"20px", width: "200px"}} onClick={(e) => {
                  e.preventDefault()
                  loginWithGithub()
                
                }}>Github</Button>
        <Button className="btn btn-warning" style={{"margin-left":"20px"}}>Google</Button>
        </ModalBody>
        <ModalFooter>
          {/* <Button color="primary" onClick={hndleAddSocialSubmit}>
            Add
          </Button>{' '} */}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default AddSocialRecoveryModal;